import {Row} from "antd";
// import axios from "axios";
import React, {useState, useRef, useEffect} from "react";
import {Button, Form} from "antd";
import {FormBox, InputBox} from "../../../components/AntdAddons";
import {ReactComponent as ArrowRight} from "../../../assets/images/icon/backToTop.svg";
import ReCAPTCHA from "react-google-recaptcha";
import {useAppDispatch} from "../../../store/app";
import {randomnumbersubstring} from "../../../utils/GlobalFunction";
import {assignErrorToInput} from "../../../store/api";
import {signUpRecord} from "../../../store/CommonSlice";
import {rules} from "./rules";
import {validateFields} from "../../../config/Global";
// import {useGoogleLogin, useGoogleOneTapLogin} from "@react-oauth/google";
// import {ReactComponent as GoogleIcon} from "../../../assets/images/icon/googleIcon34.svg";
// import {jwtDecode} from "jwt-decode";
// import {Notification} from "../../../config/Global";

const SignUp: React.FC<any> = () => {
    const [form] = Form.useForm();
    const [disabledSave, setDisabledSave] = useState(true);
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const dispatch = useAppDispatch();
    // const {countriesList} = useAppSelector((state) => state.common);

    const onChange = (value: string | null) => {
        if (value) {
            setDisabledSave(false); // Enable the button when the reCAPTCHA is completed
        } else {
            setDisabledSave(true); // Disable the button when the reCAPTCHA is not completed
        }
    };

    const resetCaptcha = () => {
        form.setFieldsValue({captcha: randomnumbersubstring()});
        if (recaptchaRef.current) {
            recaptchaRef.current.reset();
            setDisabledSave(true); // Disable the button when the reCAPTCHA is reset
        }
    };

    useEffect(() => {
        // dispatch(fetchCountriesList()).catch((error: any) => error);
        form.setFieldsValue({captcha: randomnumbersubstring()});
    }, [form]);

    const handleSignUpSubmit = (values: any) => {
        // Handle form submission logic here
        values.status = 1;
        setDisabledSave(true);
        //SignUp
        dispatch(signUpRecord(values))
            .then(() => {
                form.resetFields();
                resetCaptcha();
                setDisabledSave(false);
            })
            .catch((error: any) => {
                assignErrorToInput(form, error?.messages);
            })
            .finally(() => setDisabledSave(false));
    };

    const onValuesChange = () => {
        validateFields(form, setDisabledSave);
    };
    // useGoogleOneTapLogin({
    //     onSuccess: (credentialResponse: any) => {
    //         const googleData: any = jwtDecode(credentialResponse.credential);
    //         dispatch(
    //             signUpRecord({
    //                 name: googleData.name,
    //                 email: googleData.email,
    //                 status: 1,
    //             })
    //         )
    //             .then(() => {
    //                 setDisabledSave(false);
    //             })
    //             .catch((error: any) => {
    //                 const errors = error?.messages;
    //                 if (typeof errors === "object" && errors !== null && !isNaN(errors.length)) {
    //                     errors.map((err: string) => {
    //                         Notification.error({
    //                             message: err,
    //                         });
    //                     });
    //                 } else {
    //                     Object.keys(errors).forEach((key) => {
    //                         errors[key].map((err: string) => {
    //                             Notification.error({
    //                                 message: err,
    //                             });
    //                         });
    //                     });
    //                 }
    //                 // assignErrorToInput(form, error?.messages);
    //             })
    //             .finally(() => setDisabledSave(false));
    //         // form.setFieldsValue({name: googleData.name, email: googleData.email});
    //     },
    //     onError: () => {
    //         Notification.error({
    //             message: "SignUp with Google Failed",
    //         });
    //     },
    // });

    // const googleLogin = useGoogleLogin({
    //     onSuccess: (credentialResponse: any) => {
    //         if (credentialResponse?.access_token !== "") {
    //             axios
    //                 .get(
    //                     `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${credentialResponse.access_token}`,
    //                     {
    //                         headers: {
    //                             Authorization: `Bearer ${credentialResponse.access_token}`,
    //                             Accept: "application/json",
    //                         },
    //                     }
    //                 )
    //                 .then((res) => {
    //                     dispatch(
    //                         signUpRecord({
    //                             name: res.data.name,
    //                             email: res.data.email,
    //                             status: 1,
    //                         })
    //                     )
    //                         .then(() => {
    //                             setDisabledSave(false);
    //                         })
    //                         .catch((error: any) => {
    //                             const errors = error?.messages;
    //                             if (
    //                                 typeof errors === "object" &&
    //                                 errors !== null &&
    //                                 !isNaN(errors.length)
    //                             ) {
    //                                 errors.map((err: string) => {
    //                                     Notification.error({
    //                                         message: err,
    //                                     });
    //                                 });
    //                             } else {
    //                                 Object.keys(errors).forEach((key) => {
    //                                     errors[key].map((err: string) => {
    //                                         Notification.error({
    //                                             message: err,
    //                                         });
    //                                     });
    //                                 });
    //                             }
    //                         })
    //                         .finally(() => setDisabledSave(false));
    //                 })
    //                 .catch(() =>
    //                     Notification.error({
    //                         message: "SignUp with Google Failed",
    //                     })
    //                 );
    //         }
    //     },
    //     onError: () => {
    //         Notification.error({
    //             message: "SignUp with Google Failed",
    //         });
    //     },
    // });

    return (
        <>
            <section className="section whyThisSection signSection" id="kapturely">
                <div className="container">
                    <Row className="heading">
                        <h2>Sign Up</h2>
                    </Row>
                    <Row className="signUp">
                        <div className="footerForm">
                            {/* <Button
                                onClick={() => googleLogin()}
                                className="SocialLoginBtn"
                                icon={<GoogleIcon width="100%" />}
                            >
                                Sign up with Google
                            </Button>
                            <Divider>OR</Divider> */}
                            <FormBox
                                form={form}
                                onFinish={handleSignUpSubmit}
                                onValuesChange={onValuesChange}
                            >
                                <InputBox.Text
                                    required
                                    placeholder="Company Name"
                                    name="name"
                                    rules={rules.name()}
                                />
                                <InputBox.Text
                                    required
                                    placeholder="Email"
                                    name="email"
                                    maxLength={70}
                                    rules={rules.email()}
                                />
                                <InputBox.Text
                                    required
                                    placeholder="Mobile No"
                                    name="mobile_no"
                                    rules={rules.mobileNumber()}
                                    type="number"
                                    maxLength={10}
                                />
                                <InputBox.Password
                                    required
                                    placeholder="Password"
                                    name="password"
                                    rules={rules.password()}
                                />
                                <div className="captchaWrap">
                                    <Form.Item name="captcha">
                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey={`${process.env.REACT_APP_CAPTCHA_SITE_KEY}`} // site key
                                            onChange={onChange}
                                        />
                                    </Form.Item>
                                </div>
                                <div
                                    style={{
                                        width: "100%",
                                        position: "relative",
                                        zIndex: "9999",
                                    }}
                                >
                                    <Button
                                        className="commanBtn"
                                        htmlType="submit"
                                        disabled={disabledSave}
                                    >
                                        <span className="arrowIcon">
                                            <ArrowRight />
                                        </span>
                                        <span className="beforeIcon"></span>
                                        Sign Up
                                    </Button>
                                </div>
                            </FormBox>
                        </div>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default SignUp;
